import { isDemo } from '@dreryk/demo-variant-frontend';
import { useSessionState } from '@dreryk/egabinet-security-frontend';
import { FieldController, TranslatableText } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

const DEMO_EMAIL_PREFILL_VALUE = 'demo@dreryk.pl';

type UserCurrentEmailFieldProps = {
   readonly controller: FieldController<unknown>;
   readonly label: TranslatableText;
};

const UserCurrentEmailField = (props: UserCurrentEmailFieldProps): JSX.Element => {
   const { account } = useSessionState();
   const emailDefaultValue = isDemo() ? DEMO_EMAIL_PREFILL_VALUE : account?.login;

   return (
      <TextInput
         testId={'userCurrentEmail'}
         label={props.label}
         controller={props.controller}
         defaultValue={emailDefaultValue}
         disabled
      />
   );
};

export { UserCurrentEmailField };
